/* eslint-disable max-len */
/* eslint-disable no-await-in-loop */
import React from 'react';
import { DataSources } from '@leverege/ui-attributes';
import { GlobalState } from '@leverege/ui-redux';
import { Dialog, Toast } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { History } from '@leverege/molten-core';
import Util from "./Utils.js";
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.imagine.view.RemoveItems');

/**
 * Removes the userIds from the given action.
 */
async function onRemove({
  data
}) {
  // Get parameters
  const {
    targets,
    blueprint,
    attribute,
    selectionKey,
    onClose,
    isItem,
    deleteDevice = false
  } = data;
  const num = targets.length;
  if (num === 0) {
    onClose();
    return;
  }
  // Try to remove users
  let success = 0;
  let failure = 0;
  let err = null;
  const isDelete = attribute == null || attribute.owned || deleteDevice;
  for (let n = 0; n < num; n++) {
    try {
      // TODO: This should get the delegate from the ref
      const tgt = targets[n];
      const delegate = DataSources.getActions(tgt);
      await GlobalState.dispatch(delegate.delete({
        deleteDevice: deleteDevice ? 'force' : undefined
      }));
      success++;
      if (selectionKey) {
        GlobalState.dispatch(Selection.remove(selectionKey, tgt.id));
      }
      // If we are deleting an item in the context of an item page, push back to its parent
      if (isItem) {
        GlobalState.dispatch(History.push(delegate.parent().getUrl()));
      }
    } catch (error) {
      failure++;
      if (err == null) {
        err = error;
      }
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }

  // Successfully removed users
  const typeName = Util.blueprintName(blueprint, targets);
  if (failure === 0) {
    Toast.success(t('successTitle', {
      count: success,
      typeName,
      action: isDelete ? 'Deleted' : 'Removed'
    }));
  } else if (success === 0) {
    Toast.error([t('errorTitle', {
      count: failure,
      typeName,
      action: isDelete
    }), err.message]);
  } else {
    Toast.warn([t('warnTitle', {
      success,
      num,
      failure,
      typeName,
      action: isDelete ? 'Deleted' : 'Removed'
    }), err.message]);
  }
  onClose();
}

/**
 * Remove users dialog.
 */
export default function RemoveItems(props) {
  // Get parameters
  const {
    onClose,
    show,
    targets,
    blueprint,
    attribute,
    deleteDevice = false
  } = props;
  const num = targets?.length || 0;
  const title = num < 2 ? blueprint.name : `${num} ${blueprint.namePlural}`;
  const msg = Util.getMsgTargets(blueprint, targets);
  const isDelete = attribute == null || attribute.owned || deleteDevice;
  const button = isDelete ? t('delete') : t('remove');
  const titleType = isDelete ? t('delete') : t('remove');
  const type = isDelete ? t('DELETE') : t('remove');
  const extra = isDelete ? t('deleteWarning', {
    title
  }) : t('removeWarning');

  // Render component
  return /*#__PURE__*/_jsx(Dialog.Question, {
    show: show,
    eventData: props,
    title: t('title', {
      title,
      action: titleType
    }),
    icon: blueprint.getIcon('deleteDialogIcon') || blueprint.getIcon('screenIcon'),
    message: t('message', {
      action: type,
      msg,
      warning: extra
    }),
    okay: button,
    okayVariant: "primaryDestructive",
    onCancel: onClose,
    onOkay: onRemove
  });
}